import { z } from 'zod'
import { ValueObject } from '@lukso/controllerapps-sharedlogic-ddd-core'

const BackupPasswordPropsSchema = z.object({
  backupPasswordValue: z
    .string()
    .regex(
      /^(|[!#$%&+=@A-Z^-\da-z]+)$/,
      'Password must contain only upper and lower case characters, numbers and special characters'
    ),
})

type BackupPasswordProps = z.infer<typeof BackupPasswordPropsSchema>

export class BackupPassword extends ValueObject<BackupPasswordProps> {
  public getValue(): string {
    return this.props.backupPasswordValue
  }

  /**
   * Creates a new BackupPassword instance.
   */
  public static create(props: BackupPasswordProps): BackupPassword {
    const validatedProps = BackupPasswordPropsSchema.parse(props)
    return new BackupPassword(validatedProps)
  }
}
